import React from 'react';
import cx from "clsx";
import {Unbounded} from "next/font/google";
import OrgLinkLine from "@/app/(index)/organization/org-link-line";
import "./recruit.css";

interface IProps {
    iconIndex: string;
    active: boolean;
    name: string;
    total: number;
}

const unbounded = Unbounded({
    weight: ['400','500', '600'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const Group: React.FC<IProps> = ( { iconIndex, active, name, total} ) => {
    return (

        <div className="flex flex-col items-center">
            <div
                className={cx("h-[200px] w-[200px] border border-[#458481] rounded-full group flex flex-col gap-0 items-center", active ? "bg-[#458481]" : "")}>
                <div
                    className={cx(`h-[70px] w-full mt-[10px] mb-[5px]`, active ? `icon${iconIndex}1` : `icon${iconIndex}2`, )}></div>
                <div
                    className={cx("text-[18px] font-bold", active ? "text-white" : "text-[#458481]")}>{name}
                </div>
                <div
                    className={cx("text-[15px] font-bold", active ? "text-[#e1e1e1]" : "text-[#878787]")}>職缺數
                </div>
                <div
                    className={cx("text-[45px] font-bold leading-[40px] pt-[5px]", (active ? "text-[#cfc49a]" : "text-black"), unbounded.className)}>{total}
                </div>
            </div>
            {active && <OrgLinkLine/>}
        </div>
    );
}

export default Group;
